import React from "./_snowpack/pkg/react.js";
export const ForbiddenSection = () => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, "Forbidden");
};
